window.onload = function() {
    showPopup();
    getLocation();
    showCookiePopup();
  };


function showPopup() {
    //document.getElementById('popupgeo').style.display = 'block';
      fetch('https://ipapi.co/json/') 
      .then(response => response.json())
      .then(data => {

        const country_code = data.country_code;
            if (country_code !== 'MX') {
               if (!checkCookieConsent()) {
                 document.getElementById('popupgeo').style.display = 'block';  
                }
            }     
      })
      .catch(error => {
        console.error('Error fetching location:', error);
      }); 
}


function getLocation() {
    fetch('https://ipapi.co/json/') 
      .then(response => response.json())
      .then(data => {

        const country_code = data.country_code;
            if (country_code !== 'MX') {
              displayLocation(data);
            }
        
      })
      .catch(error => {
        console.error('Error fetching location:', error);
      });
}

function closePopup() {
    document.getElementById('popupgeo').style.display = 'none';
}

function displayLocation(data) {
    const locationText = document.getElementById('location-text');
    const button1geo =  document.getElementById('accept-btn');
  
    const country = data.country;

    if (country === "PE") { 
       locationText.innerText = "Parece que estas en Perú. ¿Deseas actualizar tu ubicación?";
       button1geo.innerText = "México";
     } else {
       locationText.innerText = "Parece que estás fuera de México. ¿Deseas continuar?";
       document.getElementById('btngeo1').style.display = 'none';
       button1geo.innerText = "ACEPTAR";
    }
}

// Function to check if the user has accepted cookies
function checkCookieConsent() {
    return document.cookie.includes('cookieConsent=true');
}

// Function to set the cookie consent in cookies
function setCookieConsent() {
    document.cookie = 'cookieConsent=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
    hideCookiePopup();
}

// Function to show the cookie popup
function showCookiePopup() {
    if (!checkCookieConsent()) {
        document.getElementById('popupgeo').style.display = 'tumama';
    }
}

// Function to hide the cookie popup
function hideCookiePopup() {
  document.getElementById('popupgeo').style.display = 'none';
}

// Event listener for the accept button
document.getElementById('accept-btn').addEventListener('click', setCookieConsent);
document.getElementById('closepoupgeo').addEventListener('click', closePopup);
